import CampaignsList from '@/pages/facebook/CampaignsList';

/**
 * Instagram campaigns view — the same campaigns list, scoped to campaigns
 * whose ad sets target Instagram (either IG-only OR cross-platform FB+IG).
 *
 * Under the hood Meta has no concept of an "Instagram campaign" — the
 * platform is decided per-ad-set via `targeting.publisher_platforms`. We
 * derive it server-side (see `fb-campaigns.service.ts`) and surface a
 * `platforms[]` array on each campaign. This wrapper just hands that scope
 * to the underlying list component.
 *
 * Cross-platform campaigns (FB + IG) appear in BOTH the Facebook module
 * AND here, each with a "Cross-platform" badge so the operator knows edits
 * apply to both placements.
 */
export default function InstagramCampaignsList() {
  return <CampaignsList platformScope="instagram" />;
}
